import { assert_string_not_empty, assert_type_boolean, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__workspace_child_enity } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/dto_workspace_child_enity';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { DTO__token } from '@shared/dto/generation/settings/token/DTO__token';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ESearchScope } from './ESearchScope';
import { ISearchSettings } from './ISearchSettings';

export class DTOSearchSettings extends DTO__workspace_child_enity implements ISearchSettings {
  static _class_name_static: string = ENUM__dto_class_name.SEARCH_SETTINGS;

  static sort(a: DTOSearchSettings, b: DTOSearchSettings) {
    let out = 0;

    if (a.is_pinned == b.is_pinned) {
      out = DTO__database_entity.sort_by_created_at_newest_first(a, b);
    } else {
      out = a.is_pinned ? -1 : 1;
    }

    return out;
  }

  /*
   * FIELDS
   */
  scope!: string; //ESearchScope

  is_pinned!: boolean;

  //if empty - search over all models
  diffusion_models: 'DTO_GENERATION_SETTING__string'[];
  //if empty - search over aspect ratios
  orientations: string[];

  //if empty - search over all images
  tokens: DTO__token[];

  hash!: string;

  /*
   * METHODS
   */

  constructor() {
    super();

    this.diffusion_models = [];
    this.orientations = [];
    this.tokens = [];
  }

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_type_enum(this.scope, ESearchScope);

    assert_type_boolean(this.is_pinned);

    assert_string_not_empty(this.hash);
  }

  has_aspect_ratio(value: string): boolean {
    return this.orientations.find(value_saved => value == value_saved) != null;
  }

  has_token(item: DTO__token): boolean {
    return this.tokens.find(item_saved => item.is_equal(item_saved)) != null;
  }
}
